import React, { useRef, useEffect } from 'react';
import { useState } from 'react';
import { Steps } from 'primereact/steps';
import { read, utils } from "xlsx";
import '../../styles/pages/addcsv.scss';
import { Button } from 'primereact/button';
import UploadComponent from './UploadComponent';
import DataTableComponent from '../../components/DataTable';
import StepsNavigation from '../../components/StepsNavigation';
import { InputText } from 'primereact/inputtext';
import AlertComponent from '../../components/Alert';
import Reviewsubmit from './Reviewsubmit';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';

import axios from "axios"

import { Toast } from 'primereact/toast';

// import Samples from '../../assets/files/Samples.xlsx';



function NewSampleManagement(props) {

    const [samples, setSamples] = useState([]);
    const [columns, setColumn] = useState([]);
    
    const [loading, setLoading] = useState(false)

    const [keys, setKeys] = useState([]);
    const dataTableLoaded = useRef(false);
    const [bulkJson, setBulkJson] = useState([]);
    const [csvErrors, setCSVErrors] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const dataTableProps = { sample: samples, columns: columns, loading: loading, dataTableLoaded: dataTableLoaded };
    const StepperProps = { activeIndex: activeIndex, setActiveIndex: setActiveIndex };
    const alertProps = { errors: [], alert: [], success: [] }

    const [userid, setUserid] = useState(null);
    const [useraccesstoken, setUseraccesstoken] = useState(null);

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const location = useLocation();
    const [name, setName] = useState(null);
    const [datasetId, setDatasetId] = useState(null);

    // Set the dataset name
    useEffect(() => {
        if (location.state){
            setName(location.state.name);
        }
    }, [location.state]);

    // set the dataset ID
    useEffect(() => {
        if (location.state){
            setDatasetId(location.state.id);
        }
    }, [location.state]);


    // Download the template file
    const downloadTemplate = () => {
        // console.log("download template");

        const link = document.createElement('a');
        link.download = 'Samples.xlsx';

        // ðŸ‘‡ï¸ set to relative path
        link.href = '/resources/Samples.xlsx';

        link.click();
    }

    // useEffect(() => {
    //     const fetchUserId = async () => {
    //         // return Cookies.get('userid');
    //         return sessionStorage.getItem('userid');
    //     }

    //     fetchUserId().then(userid => {
    //         setUserid(userid);
    //     });
    // });

    // useEffect(() => {
    //     const fetchToken = async () => {
    //         // return Cookies.get('Useraccesstoken');
    //         return sessionStorage.getItem('apitoken');
    //     }

    //     fetchToken().then(token => {
    //         setUseraccesstoken(token);
    //     });
    // });   

    useEffect(() => {

        let datasetIdLoc = null;

        if (datasetId) {
            datasetIdLoc =datasetId;
        } else if (location.state) {
            datasetIdLoc = location.state.id;
        } else {
            datasetIdLoc = null;
        }

        const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const getData = async () => {
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${datasetIdLoc}?userId=${getDataUserId}`,
              {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getDataUserToken}`,
                }
              }
            );
            setData(response.data);
            setError(null);
          } catch (err) {
            setError(err.message);
            setData(null);
          } finally {
            setLoading(false);
          }
        };
        getData();
    }, [datasetId]);

    const readCSV = (files) => {
        setLoading(true)
        const [file] = files
        const fileReader = new FileReader();
        fileReader.onload = () => {
            const arrayBuffer = fileReader.result;
            const array = new Uint8Array(arrayBuffer);
            const binaryString = String.fromCharCode.apply(null, array)
            const wb = read(binaryString, {
                type: "binary"
            });
            const sheets = wb.SheetNames;
            if (sheets.length) {
                const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], {
                    raw: true
                });
                // console.log("Array from CSV", rows);
                setSamples(rows);
                dataTableLoaded.current = true;
                const merged_obj = Object.assign({}, ...rows);
                let keys = Object.keys(merged_obj);
                setKeys(keys)
                // console.log("keys", keys);
                let data = keys.map((key) => {
                    let obj = { field: key, header: key };
                    return obj;
                });
                // console.log("column data ", data);
                setColumn(data);
                setLoading(false);
                validateCSV(rows, keys);

            }
        };
        fileReader.readAsArrayBuffer(file);
        dataTableLoaded.current = true;
    };

    const validateCSV = (csv_sample, keys) => {
        const unique_arr = checkUnique(csv_sample);
        // console.log("csv samples ", csv_sample)
        // const sample_exist_arr = checkSample(csv_sample);
        const missing_arr = checkMissingFiles(csv_sample);

        // console.log("uniques", unique_arr);
        // console.log("missing_arr", missing_arr);
        // setCSVErrors(unique_arr);
        
        const arr = [...unique_arr, ...missing_arr]

        // const arr = [missing_arr]

        setCSVErrors(arr);
        // alertProps.errors = unique_arr;
        // console.log("csv errors", csvErrors);

        // console.log("arr", arr);
        if (csvErrors.length === 0 && arr.length === 0) {
            // console.log("create Sample without errors", json.bulkJson);
            // setBulkJson(json.bulkJson)
            // sampleCreated.current = false;
            // setSuccessMessage("File upload successfully. Please click on 'Next' to proceed");
            showSticky();
        } else {
            // setSuccessMessage('');
            
        }
    }

    const checkSample = (csv_sample) => {
        const ifExistSample = [];
        const sampleData = []
        sampleData.forEach((sample_data) => {
            const sampleKey = 'Samples';
            csv_sample.forEach((data) => {
                if (data[sampleKey] === sample_data.name && !ifExistSample.includes(data[sampleKey])) {
                    ifExistSample.push({ "name": data[sampleKey] + " is already present in the system." });
                }
            });
        });

        return ifExistSample
    }

    const [serverSamples, setServerSamples] = useState([]);

    // Create a sample object before we upload the files to the server
    // useEffect(() => {

    //     if (serverSamples){

    //         console.log("serverSamples", serverSamples.length);
    //         // serverSamples.forEach((sample) => {
    //         //     console.log("sample", sample);
    //         // });
    //     }
    // }, [serverSamples]);

    const [createsamples, setCreatesamples] = useState(false);

    const checkMissingFiles = (csv_sample) => {
        const missing = []
        csv_sample.map((row) => {
            // console.log("rows from checkMissingFiles", row);

            const exist1 = Object.keys(row).includes("File1");
            const exist2 = Object.keys(row).includes("File2");
            
            if(!exist1 || !exist2){
                missing.push(row.Samples);
            } 
 
            setServerSamples(serverSamples => [...serverSamples, row]);

        });

        setCreatesamples(true);

        return missing.toString() ;
    }

    const checkUnique = (csv_sample) => {
        const obj = csv_sample.reduce((a, e) => {
            a[e.Samples] = ++a[e.Samples] || 0;
            return a;
        }, {});

        let names = Object.keys(obj);

        const unique_arr = names.filter((e) => {
            if (obj[e] > 0) {
                return e;
            } else {
                return null
            }

        }).map((filteredObj) => {
            return "Sample name " + filteredObj + " should be unique."
        });

        // console.log()
        return unique_arr;
    }

    // const createSample = (csv_sample, keys) => {
    //     let headers = keys;
    //     const attributeHeaders = [];
    //     const file_header = headers.filter((key) => {
    //         if (key.toLowerCase().includes("file")) {
    //             return key;
    //         } else if (!key.toLowerCase().includes("sample")) {
    //             attributeHeaders.push(key)
    //         }
    //     });

    //     const bulkSample = [];
    //     const files_not_uploaded = [];
    //     const no_files = [];

    //     csv_sample.forEach((data) => {
    //         const newSampleObj = {};
    //         newSampleObj.name = data.Samples;
    //         newSampleObj.files = [];
    //         newSampleObj.sampleattributes = [];
    //         attributeHeaders.forEach((key) => {
    //             newSampleObj.sampleattributes.push({ "name": key, "value": data[key] })
    //         });

    //         file_header.forEach((key) => {
    //             if (serverFilesName.length > 0) {
    //                 if (serverFilesName.includes(data[key])) {
    //                     let id = serverFiles.filter((fileObj) => {
    //                         if (fileObj.name === data[key]) {
    //                             return fileObj.id;
    //                         }
    //                     });
    //                     newSampleObj.files.push({ "id": id[0].id, "name": data[key], "file": data[key] })
    //                 } else {
    //                     if (data[key] === undefined) {
    //                         no_files.push({ "name": data.Samples + " has no files associated at column " + key , "column": key });
    //                         console.log("nofiles", no_files)
    //                     } else if (data[key].trim() !== "" && !files_not_uploaded.includes(data[key])) {
    //                         files_not_uploaded.push({ "name": data[key] + " is not uploaded on server." });
    //                         console.log("files is not uploaded ");
    //                     }

    //                 }
    //             }
    //         });

    //         bulkSample.push(newSampleObj);

    //     });

    //     const json = {
    //         "fileNotUploaded": files_not_uploaded,
    //         "noFiles": no_files,
    //         "bulkJson": {
    //             "json": bulkSample
    //         }
    //     }

    //     return json;
    // }

    // The following code is for uploading files to the server
    const [serverFiles, setServerFiles] = useState([]);

    const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

    useEffect(() => {
        // Upload the files to the server
        // Patch the files to the samples if the file names match
        // console.log("serverFiles", serverFiles);

        serverFiles.forEach((file) => {
            // console.log("file", file);
            const file1_isInSamples = serverSamples.some((sample) => {
                return sample.File1 === file.name
            });

            const file2_isInSamples = serverSamples.some((sample) => {
                return sample.File2 === file.name
            });

            let sampleId = null;

            if (file1_isInSamples){
                // patch the file to the sample
                // console.log("file1_isInSamples", file1_isInSamples);

                const filteredItems = serverSamples.filter(item => item.File1 === file.name);
                // console.log("filteredItems", filteredItems);

                const id = filteredItems.map(item => item.id)[0];
                // console.log("id", id);
                sampleId = id;
            }

            if (file2_isInSamples){
                // patch the file to the sample
                // console.log("file2_isInSamples", file2_isInSamples);

                const filteredItems = serverSamples.filter(item => item.File2 === file.name);
                // console.log("filteredItems", filteredItems);

                const id = filteredItems.map(item => item.id)[0];
                // console.log("id", id);
                sampleId = id;
            }



            // console.log("file1_isInSamples", file1_isInSamples);
            // console.log("file2_isInSamples", file2_isInSamples);

            // these are hardcoded for now
            
            const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));

            const formData = new FormData();
            formData.append('ownerId' , getDataUserId);
            formData.append('sampleId', sampleId);
            formData.append('groupId' , groupIds);
            formData.append('file'    , file);

            const headers = {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getDataUserToken}`,
            };

            axios.post( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/file`, formData, {
            headers,
            }).then((response) => {
                // console.log(response);
            }).catch((error) => {
                console.error(error);
            });
        });
    }, [serverFiles]);

    const getFileNames = (files) => {
        // console.log("files", files);
        setServerFiles(files);

        const names = files.map((file) => {
            return file.name;
        })
        // console.log("names", names);
        createSampleFromFiles(names)
    }

    useEffect(() => {
        // Create the Sample objects on the server

        // For now I'm using all of the group IDs that the user has access to
        // but we should probably only use the group ID of the "Organization" that
        // the user is currently in
        if(createsamples){
            const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
            const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
            const groupIds         = JSON.parse(sessionStorage.getItem('usergroups'));


            serverSamples.forEach((sample) => {
                // console.log("sample:", sample);

                const formData = new FormData();
                formData.append('name'     , sample.Samples);
                formData.append('ownerId'  , getDataUserId);
                formData.append('groupId'  , groupIds);
                formData.append('datasetId', datasetId);

                const headers = {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${getDataUserToken}`,
                };

                axios.post( `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample`, 
                formData, 
                {
                    headers,
                }).then((response) => {
                    if (response.status === 200){
                        sample.id = response.data.sampleid;
                    } else {
                        console.error("error creating sample");
                    }

                    if (sample.id){
                        // console.log("sample.id", sample.id);

                        // console.log("sample", sample);


                        // Now we need to add the sample attributes
                        const attributes = Object.keys(sample);

                        // console.log("attributes", attributes);

                        for (const attribute of attributes){

                            // Skip the following attributes
                            if (attribute === "Samples"){
                                continue;
                            }
                            if (attribute === "File1"){
                                continue;
                            }
                            if (attribute === "File2"){
                                continue;
                            }

                            if (attribute === "id"){
                                continue;
                            }

                            const formData = new FormData();
                            formData.append('name'     , attribute);
                            formData.append('value'    , sample[attribute]);
                            formData.append('sampleId' , sample.id);
                            formData.append('ownerId'  , getDataUserId);

                            const headers = {
                                'Content-Type': 'multipart/form-data',
                                Authorization: `Bearer ${getDataUserToken}`,
                            };

                            axios.post( `${process.env.REACT_APP_WORKFLOW_API_PATH}/wfapi/sample_attribute`,
                            formData, 
                            {
                                headers,
                            }).then((response) => {
                                // console.log(response);
                            }).catch((error) => {
                                console.error(error);
                            });
                        };
                    }
                }).catch((error) => {
                    console.error(error);
                });
            });

            // console.log("serverSamples", serverSamples);
        };
        setCreatesamples(false);

    }, [createsamples]);

    // Create a sample object before we upload the files to the server
    const createSampleFromFiles = (files) => {
        const fileNames = files;
        const sampleArr = [];
        files.forEach((name) => {
            // console.log("name in createSampleFromFiles", name);
            const newSampleObj = {};
            // newSampleObj.name = ;
            // newSampleObj.files = ;
            // newSampleObj.sampleattributes = [];
            // attributeHeaders.forEach((key) => {
            //     newSampleObj.sampleattributes.push({ "name": key, "value": data[key] })
            // }); 


            sampleArr.push(newSampleObj);
        })
    }



    const addAttribute = () => {
        console.log("add attribute");

    }

    const addSample = () => {
        console.log("add sample");
    }

    const steps = [
        {
            label: <><div className='labelStep'><span className="p-steps-number" style={activeIndex !== 0 ? { background: "#4DB054", color: "#fff" } : {}}>{activeIndex == 0 ? "1" : <i className="bi bi-check-lg"></i>}</span> Add csv/xlsx files</div></>,
            // icon: <>< <i>Add csv/xlsx files</i></>,
            body: <div className=''>
                <div className='row'>
                    <div className='col-10'>
                        <h5>Step 1 : Add csv/xlsx files</h5>
                        <p>Please upload CSV or XLSX file of metadata for the sample you would like to add, according ot the template.</p>
                        <p>In the next step you will add FASTQ file for each sample. You may skip ahead if you do not have a metadata table to provide. </p>
                    </div>
                    <div className='col-2 p-0'>
                        <Button label="Download Template" size="small" outlined className='mt-3 download-button p-button-sm p-button p-component ' icon="bi bi-download" iconPos="left" onClick={() => downloadTemplate()} />
                    </div>
                </div>
                <div className='mt-1'>
                    <UploadComponent callBackFunction={readCSV} label={"Drag & Drop csv/xlsx files here."} acceptedType={{ 'application/vnd.ms-excel': ['.xlsx', '.csv', '.xls'] }} />
                </div>
                <div className='mt-2'>
                    {samples.length > 0 &&
                        <div className='row'>
                            <div className='col'>
                                <InputText id="alphanumeric" keyfilter="alphanum" className="p-inputtext-sm" placeholder="Search" />

                            </div>
                            <div className='col text-right'>
                                <Button label="Attribute" size="small" outlined className='p-button-sm p-button p-component p-button-outlined mr-1' icon="bi bi-plus-lg" iconPos="left" onClick={() => addAttribute()} />
                                <Button label="Sample" size="small" outlined className='p-button-sm p-button p-component p-button-outlined' icon="bi bi-plus-lg" iconPos="left" onClick={() => addSample()} />
                            </div>
                        </div>
                    }
                    <DataTableComponent {...dataTableProps} />
                </div>
                <div className='mt-2'>
                    <StepsNavigation {...StepperProps} />
                </div>
            </div>
        },
        {
            label: <><div className='labelStep'><span className="p-steps-number" style={activeIndex != 1 && activeIndex != 0 ? { background: "#4DB054", color: "#fff" } : {}}>{activeIndex != 2 && activeIndex == 1 || activeIndex == 0 ? "2" : <i className="bi bi-check-lg"></i>}</span> Add fastq files </div> </>,
            // icon:<><i className="fa-solid fa-2"> </i> <i>Add fastq files </i></> ,
            body: <div className=''>
                <div className='row'>
                    <div className='col-10'>
                        <h5>Step 2 : Add fastq files</h5>
                        <p>Upload g-zipped FASTQ file for each sample.Once a file has been added its name changes from gray to black in the table below.</p>
                        <p>You can also make edit to the table. Click "continue" to initiate large file upload and quality check. </p>
                    </div>
                    <div className='col-2 p-0'>
                        
                        <Button label="Download Template" size="small" outlined className='mt-3 download-button p-button-sm p-button p-component ' icon="bi bi-download" iconPos="left" onClick={() => downloadTemplate()} />

                    </div>
                </div>
                <div className='mt-1'>
                    <UploadComponent callBackFunction={getFileNames} label={"Drag & Drop fastq files here."} acceptedType={{ "text/plain": ['.fastq', '.fastq.gz', '.gz'] }} />
                </div>
                <div className='mt-2'>
                    {samples.length > 0 &&
                        <div className='row'>
                            <div className='col-3'>
                                <InputText id="alphanumeric" keyfilter="alphanum" className="w-full p-inputtext-sm" placeholder="Search" />

                            </div>
                            <div className='col-6 text-center'>
                               {csvErrors.length > 0 &&  <AlertComponent errors={csvErrors} /> }
                            </div>
                            <div className='col-3 text-right'>
                                <Button label="Attribute" size="small" outlined className='p-button-sm p-button p-component p-button-outlined mr-1' icon="bi bi-plus-lg" iconPos="left" onClick={() => addAttribute()} style={{"padding":"10px"}} />
                                <Button label="Sample" size="small" outlined className=' p-button-sm p-button p-component p-button-outlined' icon="bi bi-plus-lg" iconPos="left" onClick={() => addSample()}  style={{"padding":"10px"}} />
                            </div>
                        </div>
                    }
                    <DataTableComponent {...dataTableProps} />
                </div>
                <div className='mt-2'>
                    <StepsNavigation {...StepperProps} />
                </div>
            </div>
        },
        {
            label: <><div className='labelStep'><span className="p-steps-number">3</span> Review & submit</div></>,
            // icon: <><i className="fa-solid fa-3"></i><i>Upload Samples</i></>,
            body: <div className=" mb-3">
                <Reviewsubmit />
                <div className='mt-2'>
                    <StepsNavigation {...StepperProps} />
                </div>

            </div>
        }

    ];

    const toast = useRef(null);

    const showSticky = () => {
        toast.current.show({ severity: 'info', summary: 'File {Filename} Imported Successfully', detail: 'Message Content', sticky: true });
    };

    const clear = () => {
        toast.current.clear();
    };

    return (
        <main className='add-csv mt-2'>
            <p>{name} : {datasetId}</p>
            <Toast ref={toast} />
            <Steps model={steps} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false}>
            </Steps>
            <div className="mt-3 pt-3 border-top">{steps[activeIndex].body}</div>
        </main>
    );
}

export default NewSampleManagement;